<template>
  <v-row class="mx-auto">
    <v-col class="pb-0" cols="12">
      <v-data-table
        id="expurgo-registro-entidades"
        v-model="selectedItemLocal"
        :headers="headers"
        :items="items"
        item-key="key"
        :single-select="false"
        show-select
        :loading="loading"
        :hide-default-header="loading"
        :sort-by="['entidade', 'registros']"
        class="elevation-1"
        hide-default-footer
        disable-pagination
        no-results-text="Nenhum registro correspondente encontrado"
      >
        <template v-slot:[`item.numero_registros`]="{ item }">
          {{ item.numero_registros | parseNumberToIntegerBR }}
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    props: {
      itemsTable: {
        type: Array,
        default: () => []
      },
      selectedItem: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        default: false
      }
    },

    emits: ['update:selectedItem', 'stepReleased'],

    data: () => ({
      items: [],
      headers: [
        {
          text: 'Entidade',
          align: 'center',
          value: 'tabela_origem'
        },
        {
          text: 'Registros',
          align: 'center',
          value: 'numero_registros'
        }
      ]
    }),

    computed: {
      selectedItemLocal: {
        get() {
          return this.selectedItem;
        },
        set(newValue) {
          this.$emit('update:selectedItem', newValue);
        }
      }
    },

    watch: {
      itemsTable() {
        this.items = this.itemsTable.map((item) => {
          item.key = item.tabela_origem + '-' + item.numero_registros;
          return item;
        });
      },
      selectedItem(arrNewVal) {
        this.$emit('stepReleased', arrNewVal.length);
      }
    }
  };
</script>